module.exports = __webpack_public_path__ + "img/kleisma3m-m@1.2d036ae1.jpg";